export const accountProfileSection = {
  kicker: 'Участник',
  // Email / Телефон — основные поля видимые в карточке профиля справа.
  // Имя/фамилия — отдельно: показываем как заголовок над списком.
  fields: [
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Телефон' }
  ],
  empty: 'не указано',
  editHint: 'Редактирование данных — через организатора форума.',
  fallbackName: 'Участник форума'
};

export function fullNameFromProfile(profile) {
  if (!profile) return '';
  const parts = [profile.first_name, profile.last_name].filter(Boolean);
  return parts.join(' ');
}

export function formatPhone(raw) {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  // 7XXXXXXXXXX → +7 (XXX) XXX-XX-XX
  if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    const d = '7' + digits.slice(1);
    return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9, 11)}`;
  }
  if (digits.length === 10) {
    return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
  }
  return digits;
}

export function profileFields(profile) {
  const phoneRaw = profile?.phone_1 || profile?.phone_2 || '';
  return {
    name: fullNameFromProfile(profile),
    email: profile?.email ?? '',
    phone: formatPhone(phoneRaw)
  };
}
